import { render, staticRenderFns } from "./loginSafe.vue?vue&type=template&id=bcc661ce&scoped=true&"
import script from "./loginSafe.vue?vue&type=script&lang=js&"
export * from "./loginSafe.vue?vue&type=script&lang=js&"
import style0 from "./loginSafe.vue?vue&type=style&index=0&id=bcc661ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc661ce",
  null
  
)

export default component.exports